var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRecentExchangesIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "svg-fill",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22 12C22 6.47701 17.523 2 12 2C10.5675 1.99867 9.15146 2.30574 7.84817 2.90036C6.54489 3.49497 5.38488 4.36319 4.447 5.446L2 3V9H8L5.865 6.865C7.07237 5.42233 8.74954 4.45129 10.6018 4.1225C12.4541 3.79372 14.363 4.12821 15.9931 5.06722C17.6233 6.00623 18.8703 7.48967 19.5152 9.25692C19.6775 9.70159 19.799 10.1571 19.8798 10.6179C20.6772 10.9783 21.395 11.4837 21.9995 12.1005C21.9998 12.067 22 12.0335 22 12ZM12.1005 21.9995C11.4835 21.3948 10.978 20.6767 10.6176 19.879C10.6163 19.8788 10.6151 19.8786 10.6138 19.8784C8.76104 19.5524 7.0824 18.5839 5.87283 17.1431C4.66326 15.7023 4.00015 13.8812 4 12H2C2 17.523 6.477 22 12 22C12.0335 22 12.0671 21.9998 12.1005 21.9995Z",
    fill: "#F8FAFC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "svg-fill",
    d: "M17 23C13.6862 23 11 20.3138 11 17C11 13.6862 13.6862 11 17 11C20.3138 11 23 13.6862 23 17C23 20.3138 20.3138 23 17 23ZM17 21.8C18.273 21.8 19.4939 21.2943 20.3941 20.3941C21.2943 19.4939 21.8 18.273 21.8 17C21.8 15.727 21.2943 14.5061 20.3941 13.6059C19.4939 12.7057 18.273 12.2 17 12.2C15.727 12.2 14.5061 12.7057 13.6059 13.6059C12.7057 14.5061 12.2 15.727 12.2 17C12.2 18.273 12.7057 19.4939 13.6059 20.3941C14.5061 21.2943 15.727 21.8 17 21.8ZM14 17.6H19.4V18.8H17V20.6L14 17.6ZM17 15.2V13.4L20 16.4H14.6V15.2H17Z",
    fill: "#F8FAFC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecentExchangesIcon);
export default __webpack_public_path__ + "static/media/recent_exchanges_icon.8ae8c9dd7c8038f87122ece9b5ed3e0a.svg";
export { ForwardRef as ReactComponent };